export const TARGET_ALL = 0
export const TARGET_MAIL = 1
export const TARGET_REMOTE_NOTIFICATION = 2
